import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export function ProjectFields({ isSticker, form, setForm }) {
  return isSticker ? (
    <div className="grid sm:grid-cols-2 gap-5">
      <div>
        <Label>Pack size</Label>
        <Select value={form.tier} onValueChange={(v) => setForm({...form, tier: v})}>
          <SelectTrigger data-testid="order-tier"><SelectValue/></SelectTrigger>
          <SelectContent>
            <SelectItem value="sticker-10">Sticker Pack · 10 — $20</SelectItem>
            <SelectItem value="sticker-50">Sticker Pack · 50 — $55</SelectItem>
            <SelectItem value="sticker-100">Sticker Pack · 100 — $85</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label>Finish</Label>
        <Select value={form.material} onValueChange={(v) => setForm({...form, material: v})}>
          <SelectTrigger data-testid="order-material"><SelectValue/></SelectTrigger>
          <SelectContent>
            {["Vinyl","Holographic","Glitter","Clear","Matte"].map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
  ) : (
    <div className="grid sm:grid-cols-2 gap-5">
      <div>
        <Label>Preferred material</Label>
        <Select value={form.material} onValueChange={(v) => setForm({...form, material: v})}>
          <SelectTrigger data-testid="order-material"><SelectValue/></SelectTrigger>
          <SelectContent>
            {["Walnut","Maple","Cherry","Oak","Brass","Copper","Stainless Steel","Slate","Leather","Glass","Not sure — recommend one"].map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label>Complexity</Label>
        <Select value={form.complexity} onValueChange={(v) => setForm({...form, complexity: v})}>
          <SelectTrigger data-testid="order-complexity"><SelectValue/></SelectTrigger>
          <SelectContent>
            <SelectItem value="simple">Simple — text + basic monogram</SelectItem>
            <SelectItem value="standard">Standard — logo + light decoration</SelectItem>
            <SelectItem value="detailed">Detailed — photo etching, inlays, fine art</SelectItem>
            <SelectItem value="not-sure">Not sure — your call</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="sm:col-span-2">
        <Label>When do you need it by?</Label>
        <Input data-testid="order-deadline" placeholder="e.g. 'By December 15, 2026' or 'No rush'" value={form.desired_deadline} onChange={(e) => setForm({...form, desired_deadline: e.target.value})}/>
      </div>
    </div>
  );
}
